import { useCallback } from 'react';

/** Single click raises immediately; double-click plays (handled via onDoubleClick). */
export function useCardActivate({ onRaise }) {
  return useCallback((cardId) => {
    onRaise?.(cardId);
  }, [onRaise]);
}